<template>

  <div class="container-fluid container-temperature">
    <div class="tab-header" v-if="warehouses">
      <form action="" class="d-flex flex-column justify-content-center" @submit.prevent="getResult">

        <div class="col-12 d-flex align-items-center ">
          <div class="col-md-2 col-sm-4 form-group mb-3">
            <label for="filter-wr-name" class="form-label">საწყობი</label>
            <v-select v-model="warehouse" label="name" id="filter-wr-name"
                       :options="warehouses.list"
                      placeholder="აირჩიეთ საწყობი"
                      @option:selected="onChangeWarehouse"
                      :class="v$.warehouse.$error ? 'red' : ''"
            >
              <template v-slot:no-options>სია ცარიელია</template>
            </v-select>

          </div>

          <div class="col-md-2 col-sm-4 form-group mb-3">
            <label for="room-name" class="form-label">ოთახი</label>
            <v-select v-model="selectedRoom"  label="name" id="room-name" :options="rooms"
                      placeholder="აირჩიეთ ოთახი"
                      @option:selected="onChangeRooms"
                      :class="v$.selectedRoom.$error ? 'red' : ''"
            >
              <template v-slot:no-options>სია ცარიელია</template>
            </v-select>
          </div>

          <div class="col-md-2 col-sm-4 form-group mb-3">
            <label for="sensor-name" class="form-label">სენსორი</label>
            <v-select v-model="sensor" label="name" id="sensor-name" :options="sensors"
                      placeholder="აირჩიეთ სენსორი"
                      :class="v$.sensor.$error ? 'red' : ''"
            >
              <template v-slot:option="sensor">
                {{sensor.name}}  {{sensor.description !== null && sensor.description !== "" && typeof sensor.description !== "undefined" ? `- ${sensor.description} ` : '' }}
              </template>
              <template v-slot:no-options>სია ცარიელია</template>
            </v-select>
          </div>

          <div class="form-group mb-3 dropdown-height">
            <label for="period-name" class="form-label ">პერიოდი</label>
            <DateRangePicker element-id="range-daterange" date-range-value="dateRangeValue" />
          </div>

<!--          <div class="col-1 form-group mb-3 dropdown-height">-->
<!--            <label for="interval-name" class="form-label">ინტერვალი</label>-->

<!--            <input type="text" v-model="interval" class="form-control" placeholder="ინტერვალი" >-->

<!--          </div>-->

          <div class="col-md-2 col-sm-4 form-group  button-groups d-flex">
            <button type="button" class="btn btn-filter" @click="showTemperatureFilter">
              <img src="/svgs/filter2.svg" alt="">
            </button>
            <button type="submit" class="btn btn-primary">
              გენერირება
            </button>
						<button type="button" class="btn btn-primary" @click="exportExcel">
							Excel
						</button>

          </div>


        </div>

        <transition name="fade" mode="out-in">
          <div class=" row additional-filter" v-if="isShowingExtraFilter">

            <div class="col-md-2 col-sm-4 no-padding-div timerange-col">
              <div class="input-group addon-filter">
              <span class="input-group-text no-padding" id="basic-addon2">
                დროის მონაკვეთი
              </span>
                <v-select v-model="timeRangeStart" class="addon-select" label="name"
                          id="interval-name-start" :options="timeArray" value="00:00">
                  <template v-slot:no-options>სია ცარიელია</template>
                </v-select>
                <span class="input-group-text no-padding" >
                  <img :src="'/svgs/clock.svg'" >
                </span>
                <v-select v-model="timeRangeEnd" class="addon-select second-addon-select"
                          label="name" id="interval-name-end" :options="timeArray" value="24:00">
                  <template v-slot:no-options>სია ცარიელია</template>
                </v-select>
              </div>
            </div>

            <div class="col-md-2 col-sm-4 temp-input-lg no-padding-div ">
              <div class="input-group addon-filter">
                <span class="input-group-text no-padding" id="basic-addon2">
                  ტემპერატურა
                </span>
                <input type="number" name="start1" v-model="this.start1"  class="form-control rem-extra-padding " step="0.1" >
                <span class="input-group-text no-padding" >
                  <img :src="'/svgs/temp-green.svg'" >
                </span>
                <input type="number" name="end1" v-model="this.end1"
                       :class="v$.end1.$error ? 'form-control rem-extra-padding red' : 'form-control rem-extra-padding' "
                       step="0.1">
              </div>
            </div>

            <div class="col-md-1 col-sm-12 temp-input no-padding-div" >
              <div class="input-group addon-filter">
                <input type="number" name="start2" v-model="this.start2"
                       :class="v$.start2.$error ? 'form-control rem-extra-padding red' : 'form-control rem-extra-padding' "
                       step="0.1" >
                <span class="input-group-text no-padding" id="eye-addon">
                  <img :src="'/svgs/temp-green.svg'" >
                </span>
                <input type="number" name="end2" v-model="this.end2"
                       :class="v$.end2.$error ? 'form-control rem-extra-padding red' : 'form-control rem-extra-padding' "
                       step="0.1" >
              </div>
            </div>

            <div class="col-md-1 col-sm-4 temp-input no-padding-div">
              <div class="input-group addon-filter extra-input-width">
                <input type="number" name="start3" v-model="this.start3"
                       :class="v$.start3.$error ? 'form-control rem-extra-padding red' : 'form-control rem-extra-padding' "
                       step="0.1" >
                <span class="input-group-text no-padding" id="eye-addon">
                  <img :src="'/svgs/temp-green.svg'" >
                </span>
                <input type="number" name="end3" v-model="this.end3"
                       :class="v$.end3.$error ? 'form-control rem-extra-padding red' : 'form-control rem-extra-padding' "
                       step="0.1">
              </div>
            </div>

            <div class="col-md-1 col-sm-4 temp-input no-padding-div">
              <div class="input-group addon-filter">
                <input type="number" name="start4" v-model="this.start4"
                       :class="v$.start4.$error ? 'form-control rem-extra-padding red' : 'form-control rem-extra-padding' "
                       step="0.1" >
                <span class="input-group-text no-padding" id="eye-addon">
                  <img :src="'/svgs/temp-green.svg'" >
                </span>
                <input type="number" name="end4" v-model="this.end4"
                       :class="v$.end4.$error ? 'form-control rem-extra-padding red' : 'form-control rem-extra-padding' "
                        step="0.1" >
              </div>
            </div>

            <div class="col-md-1 col-sm-4 temp-input no-padding-div">
              <div class="input-group addon-filter">
                <input type="number" name="start5" v-model="this.start5"
                       :class="v$.start5.$error ? 'form-control rem-extra-padding red' : 'form-control rem-extra-padding' "
                       step="0.1" >
                <span class="input-group-text no-padding" id="eye-addon">
                  <img :src="'/svgs/temp-green.svg'" >
                </span>
                <input type="number" name="end5" v-model="this.end5" class="form-control rem-extra-padding" step="0.1" >
              </div>
            </div>


            <div class="col-lg-3 col-sm-12 week-col">
              <div class="input-group week-groups">
                <span :class="'input-group-text ' + isSelectedWeek(1)" id="basic-addon3" @click="selectWeek(1)">
                  ორ
                </span>
                <span :class="'input-group-text ' + isSelectedWeek(2)" @click="selectWeek(2)" id="basic-addon4">
                  სმ
                </span>
                <span :class="'input-group-text ' + isSelectedWeek(3)" @click="selectWeek(3)" id="basic-addon5">
                  ოთხ
                </span>
                <span :class="'input-group-text ' + isSelectedWeek(4)" @click="selectWeek(4)" id="basic-addon6">
                  ხთ
                </span>
                <span :class="'input-group-text ' + isSelectedWeek(5)" @click="selectWeek(5)" id="basic-addong7">
                  პრ
                </span>
                <span :class="'input-group-text ' + isSelectedWeek(6)" @click="selectWeek(6)" id="basic-addon8">
                  შბ
                </span>
                <span :class="'input-group-text ' + isSelectedWeek(7)" @click="selectWeek(7)" id="basic-addon9">
                  კვ
                </span>
              </div>
            </div>
          </div>
        </transition>

      </form>
    </div>

    <div class="col-12 tab-content">

      <transition name="fade" mode="out-in">

        <table class="table" v-if="!this.loading && resultData && resultData.data">
          <thead>
          <tr>
            <th>მინ °C</th>
            <th>საშ °C</th>
            <th>მაქს °C</th>
            <th> {{ this.start1 ? this.start1 : '' }}° <img src="/svgs/arrows.svg" alt=""> {{ this.end1 ? this.end1 : '' }}°</th>
            <th> {{ this.start2 ? this.start2 : '' }}° <img src="/svgs/arrows.svg" alt=""> {{ this.end2 ? this.end2 : '' }}°</th>
            <th> {{ this.start3 ? this.start3 : '' }}° <img src="/svgs/arrows.svg" alt=""> {{ this.end3 ? this.end3 : '' }}°</th>
            <th> {{ this.start4 ? this.start4 : '' }}° <img src="/svgs/arrows.svg" alt=""> {{ this.end4 ? this.end4 : '' }}°</th>
            <th> {{ this.start5 ? this.start5 : '' }}° <img src="/svgs/arrows.svg" alt=""> {{ this.end5 ? this.end5 : '' }}°</th>
            <th>ჯამში</th>
            <th> {{ this.start1 ? this.start1 : '' }}° <img src="/svgs/arrows.svg" alt=""> {{ this.end1 ? this.end1 : '' }}°</th>
            <th> {{ this.start2 ? this.start2 : '' }}° <img src="/svgs/arrows.svg" alt=""> {{ this.end2 ? this.end2 : '' }}°</th>
            <th> {{ this.start3 ? this.start3 : '' }}° <img src="/svgs/arrows.svg" alt=""> {{ this.end3 ? this.end3 : '' }}°</th>
            <th> {{ this.start4 ? this.start4 : '' }}° <img src="/svgs/arrows.svg" alt=""> {{ this.end4 ? this.end4 : '' }}°</th>
            <th> {{ this.start5 ? this.start5 : '' }}° <img src="/svgs/arrows.svg" alt=""> {{ this.end5 ? this.end5 : '' }}°</th>
            <th>ჯამში</th>
            <th> {{ this.start1 ? this.start1 : '' }}° <img src="/svgs/arrows.svg" alt=""> {{ this.end1 ? this.end1 : '' }}°</th>
            <th> {{ this.start2 ? this.start2 : '' }}° <img src="/svgs/arrows.svg" alt=""> {{ this.end2 ? this.end2 : '' }}°</th>
            <th> {{ this.start3 ? this.start3 : '' }}° <img src="/svgs/arrows.svg" alt=""> {{ this.end3 ? this.end3 : '' }}°</th>
            <th> {{ this.start4 ? this.start4 : '' }}° <img src="/svgs/arrows.svg" alt=""> {{ this.end4 ? this.end4 : '' }}°</th>
            <th> {{ this.start5 ? this.start5 : '' }}° <img src="/svgs/arrows.svg" alt=""> {{ this.end5 ? this.end5 : '' }}°</th>
            <th>ჯამში</th>
          </tr>

          </thead>
          <tbody>
          <tr v-for="result in resultData.data" v-bind:key="result">
            <td>{{result.min}}</td>
            <td>{{result.avg}}</td>
            <td>{{result.max}}</td>
            <td>{{result.rangetime1readable}}</td>
            <td>{{result.rangetime2readable}}</td>
            <td>{{result.rangetime3readable}}</td>
            <td>{{result.rangetime4readable}}</td>
            <td>{{result.rangetime5readable}}</td>
            <td>{{result.fulltime}}</td>
            <td>{{result.range1}}</td>
            <td>{{result.range2}}</td>
            <td>{{result.range3}}</td>
            <td>{{result.range4}}</td>
            <td>{{result.range5}}</td>
            <td>{{result.full_percent_count}}</td>
            <td>{{ Math.round((result.range1percent + Number.EPSILON) * 100) / 100 + '%' }}</td>
            <td>{{ Math.round((result.range2percent + Number.EPSILON) * 100) / 100 + '%' }}</td>
            <td>{{ Math.round((result.range3percent + Number.EPSILON) * 100) / 100 + '%' }}</td>
            <td>{{ Math.round((result.range4percent + Number.EPSILON) * 100) / 100 + '%' }}</td>
            <td>{{ Math.round((result.range5percent + Number.EPSILON) * 100) / 100 + '%' }}</td>
            <td>{{ Math.round((result.fullpercent + Number.EPSILON) * 100) / 100 + '%' }}</td>
          </tr>
          </tbody>
        </table>
      </transition>

      <transition name="fade" mode="out-in">
        <LoaderItem custom-classes="splash-screen-child" v-if="this.loading"></LoaderItem>
      </transition>

    </div>
  </div>

</template>

<script>

import {ref} from "vue";
import DateRangePicker from "@/components/partials/reusable/DateRangePicker";
import useVuelidate from "@vuelidate/core";
import {required} from "@vuelidate/validators";
import LoaderItem from "@/components/partials/LoaderItem";

export default {
  name:'TemperatureRangeReport',
  components:{DateRangePicker, LoaderItem},
  computed:{
    templateData(){
      return this.$store.state.reports.template
    },
    resultData(){
      return this.$store.state.reports.rangeList.data
    },

    warehouses(){
      return this.$store.state.warehouse.list.data
    },
    rooms(){
      if (this.$store.state.warehouse.rooms.data){
        return this.$store.state.warehouse.rooms.data.list
      }
      return []
    },
    sensors(){
      if (this.$store.state.warehouse.sensors.sensors){
        return this.$store.state.warehouse.sensors.sensors
      }
      return []
    }
  },
  methods:{
    showTemperatureFilter(){
      this.isShowingExtraFilter = !this.isShowingExtraFilter
    },
    onChangeWarehouse(element){
      this.$store.dispatch('warehouse/getWarehouseRooms', element.id).then(
          () => {
            this.sensor = null
            if (this.rooms.length > 0){
              this.onChangeRooms(this.rooms[0])
            }else{
              this.selectedRoom = null
              this.$store.state.warehouse.sensors = []
              this.sensor = null
            }
          }
      )
    },
    onChangeRooms(element){
      this.$store.dispatch('warehouse/getWarehouseRoomSensors', element.id).then(
          () => {
            if (!this.sensor){
              this.selectedRoom = this.rooms[0]
            }
            this.sensor = this.sensors[0]
          }
      )
    },
    selectWeek(week){
      this.weeksArray[week] ? delete this.weeksArray[week] : this.weeksArray[week] = week
    },
    isSelectedWeek(weekIndex){
      return this.weeksArray[weekIndex] ? 'active-week' : '';
    },
		async exportExcel(){
			const result = await this.v$.$validate()
			if (!result) {
				// notify user form is invalid
				return 0
			}else{
				this.loading = true
				let filterData = {
					interval: this.interval,
					weekdays: this.weeksArray.join(','),
					dateRange: document.getElementById('range-daterange').value.replace(/\./g,'/'),
					sensorimei: this.sensor.imei,
					sensorindex: this.sensor.index,
					warehouseid: this.warehouse.id,
					room_id: this.selectedRoom.id,
					timeRangeStart: this.timeRangeStart,
					timeRangeEnd: this.timeRangeEnd,
					start1:this.start1, end1: this.end1, start2: this.start2, end2: this.end2,
					start3: this.start3, end3: this.end3, start4: this.start4, end4: this.end4,
					start5: this.start5, end5: this.end5
				}
				this.$store.dispatch('reports/TemperatureRangeReportsExport', filterData).then(
						()  => {
							let report = this.$store.state.reports.list
							this.loading = false
							this.last_page = report.last_page
							this.page = report.current_page
						}
				)
			}

		},
    async getResult(){
      const result = await this.v$.$validate()
      if (!result) {
        return 0
      }else{
        this.loading = true
        let filterData = {
          interval: this.interval,
          weekdays: this.weeksArray.join(','),
          dateRange: document.getElementById('range-daterange').value.replace(/\./g,'/'),
          sensorimei: this.sensor.imei,
          sensorindex: this.sensor.index,
          warehouseid: this.warehouse.id,
          room_id: this.selectedRoom.id,
          timeRangeStart: this.timeRangeStart,
          timeRangeEnd: this.timeRangeEnd,
          start1:this.start1, end1: this.end1, start2: this.start2, end2: this.end2,
          start3: this.start3, end3: this.end3, start4: this.start4, end4: this.end4,
          start5: this.start5, end5: this.end5
        }
        this.$store.dispatch('reports/getTemperatureRangeReports', filterData).then(
            ()  => this.loading = false
        )
      }

    }
  },
  setup () {
    return { v$: useVuelidate() }
  },
  data(){
    const timeArray = [
      '00:00', '01:00', '02:00', '03:00',
      '04:00', '05:00', '06:00', '07:00',
      '08:00', '09:00', '10:00', '11:00',
      '12:00', '13:00', '14:00', '15:00',
      '16:00', '17:00', '18:00', '19:00',
      '20:00', '21:00', '22:00', '23:00',
      '24:00',
    ]



    const room = ref('')
    return {
      timeArray,
      isShowingExtraFilter:true,
      room,
      warehouse: ref(null),
      selectedRoom: ref(null),
      sensor: ref(null),
      interval: ref('5'),
      timeRangeStart: ref('00:00'),
      timeRangeEnd: ref('24:00'),
      dateRangeValue: ref(null),
      loading: false,
      weeksArray:['',1,2,3,4,5,6,7],
      start1:null, end1:null,
      start2:null, end2:null,
      start3:null, end3:null,
      start4:null, end4:null,
      start5:null, end5:null
    }
  },
  mounted() {
    this.$store.dispatch('warehouse/getWarehouseList').then(
        () => {
          this.loading = false
          this.warehouse = this.warehouses.list[0]
          this.onChangeWarehouse(this.warehouse)
        }
    )
    this.$store.dispatch('reports/getTemperatureRangeReportTemplate').then(
        () => {
          this.start1 = this.templateData.data.template.start1
          this.end1 = this.templateData.data.template.end2
          this.start2 = this.templateData.data.template.start2
          this.end2 = this.templateData.data.template.end2
          this.start3 = this.templateData.data.template.start3
          this.end3 = this.templateData.data.template.end3
          this.start4 = this.templateData.data.template.start4
          this.end4 = this.templateData.data.template.end4
          this.start5 = this.templateData.data.template.start5
          this.end5 = this.templateData.data.template.end5
        }
    )
  },
  validations () {
    return {
      warehouse: { required },
      selectedRoom: { required },
      sensor: { required },
      interval: { required },
      end1: { },
      start2: { },
      end2: { },
      start3: { },
      end3: { },
      start4: { },
      end4: { },
      start5: { },

    }
  }
}
</script>

<style scoped>

.container-temperature{
  padding-left: 0;
  padding-right: 0;
}

.tab-header{
  padding:15px
}

.form-group:not(:first-child){
  margin-left: 10px;
}


.rem-extra-padding{
  padding-right: 0;
  /*padding-left: 5px;*/
}

.vs__dropdown-toggle{
  height: 100% !important;
  border: 1px solid var(--dropzone-border) !important;
  min-width: 100px;
}

.vs__search{
  display: block !important;
  padding: .11rem 0 !important;
}


.addon-select > .vs__dropdown-toggle{
  border: 1px solid var(--dropzone-border);
  border-left: 0 !important;
  border-radius: 0;
  border-right: 0;
}

 .second-addon-select > .vs__dropdown-toggle{
   border-left: 0 !important;
   border-right: 1px solid var(--dropzone-border);
   border-top-right-radius: 5px !important;
   border-bottom-right-radius: 5px !important;
 }

 .form-control{
   border: 1px solid var(--dropzone-border);
 }

 .red{
   border-radius: 5px;
   border: 1px solid red !important;
 }

.splash-screen-child{
  position: relative !important;
  padding-top: 5% !important;
  display: flex;
  justify-content: center;
  align-items: center;
  height: auto;
}

.input-group-text.active-week{
  background: var(--submit-button-bg) !important;
  color: #ffffff !important;
}

.table{
  color:var(--second-titles);
  font-family: "TBCDinNusxuri-Medium";
  font-size: 16px;
}
.table > :not(:first-child){
  border: 1px solid var(--border-color) !important;
}
.table tbody tr:last-child{
  border: transparent;
}
.table tbody tr:hover{
  background: var(--hover-item);
  cursor: pointer;
}

.table > thead{
  vertical-align: middle;
  color: var(--text-sub-bold-color);
}

.table > :not(:first-child){
  border-top: 1px solid var(--border-color);
}

.table td:first-child, table th:first-child{
  padding-left: 20px;
}

.no-padding-div{
  padding-left: 5px;
  padding-right: 5px;
}

input[type='number'] {
  -moz-appearance:textfield;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

.input-group-text img{
  height: 20px;
}

</style>